import {
	SharedRouter,
	PreviewRouter,
	UnathorisedRouter,
	HomeRouter,
	MainRouter
} from "../routers/index";
import ForgotPassword from "../../pages/shared/ForgotPassword";
import { lazy } from "react";

const LazyHome = lazy(() =>
	import("../../pages/shared/LandingPage/landingPage")
);
const LazyChangeEmail = lazy(() => import("../../pages/shared/ChangeEmail"));
const LazyAdmissionProcess = lazy(() =>
	import("../../pages/shared/AdmissionProcess")
);
const LazyPortalProcess = lazy(() =>
	import("../../pages/shared/PortalProcess")
);
const LazyLogin = lazy(() => import("../../pages/shared/Login/login"));
const LazyResetPassword = lazy(() =>
	import("../../pages/shared/ResetPassword")
);
const LazyVerifyAccount = lazy(() =>
	import("../../pages/shared/VerifyAccount")
);
const LazyCreateProfile = lazy(() =>
	import("../../pages/shared/CreateProfile/createProfille")
);
const LazyCreateAccount = lazy(() =>
	import("../../pages/shared/CreateAccount/createAccount")
);
const LazyOtpVerfication = lazy(() =>
	import("../../pages/shared/OtpVerfication")
);
const LazyVerifyConfirmation = lazy(() =>
	import("../../pages/shared/VerifyConfirmation")
);
const LazyGenerateJupebStudentsPaymentInvoice = lazy(() =>
	import(
		"../../pages/shared/JupebStudents/pages/GenerateJupebStudentsPaymentInvoice/generateJupebStudentsPaymentInvoice"
	)
);
const LazyJupebStudentsInvoice = lazy(() =>
	import(
		"../../pages/shared/JupebStudents/pages/Invoice/JupebStudentsInvoice"
	)
);
const LazyGenerateJambPaymentInvoice = lazy(() =>
	import(
		"../../pages/shared/JambStudents/pages/GenerateJambPaymentInvoice/generateJambPaymentInvoice"
	)
);
const LazyGenerateCSEInvoice = lazy(() =>
	import(
		"../../pages/shared/CSEInvoiceGeneration/pages/GenerateCSEInvoice/generateCSEInvoice"
	)
);
const LazyJambStudentsInvoice = lazy(() =>
	import("../../pages/shared/JambStudents/pages/Invoice/jambStudentsInvoice")
);
const LazyCSEInvoice = lazy(() =>
	import("../../pages/shared/CSEInvoiceGeneration/pages/Invoice/CSEInvoice")
);
const LazyJupebApplicationLogin = lazy(() =>
	import("../../pages/shared/JupebApplication/jupebApplicationLogin")
);
const LazyJupebApplication = lazy(() =>
	import("../../pages/shared/JupebApplication/jupebApplication")
);
const LazyJupebApplicationPreview = lazy(() =>
	import("../../pages/shared/JupebApplication/jupebApplicationPreview")
);
const LazyPutmeLogin = lazy(() =>
	import("../../pages/shared/PUTMEApplication/putmeLogin")
);
const LazyPutmeApplication = lazy(() =>
	import("../../pages/shared/PUTMEApplication/putmeApplication")
);
const LazyPutmeApplicationDetails = lazy(() =>
	import(
		"../../pages/shared/PUTMEApplication/PutmeApplicationDetails/putmeApplicationDetails"
	)
);
const LazyPutmePreview = lazy(() =>
	import("../../pages/shared/PUTMEApplication/putmePreview")
);
const LazyDirectEntryLogin = lazy(() =>
	import("../../pages/shared/DirectEntryApplication/directEntryLogin")
);
const LazyDirectEntryApplication = lazy(() =>
	import("../../pages/shared/DirectEntryApplication/directEntryApplication")
);
const LazyDirectEntryApplicationDetails = lazy(() =>
	import(
		"../../pages/shared/DirectEntryApplication/DirectEntryApplicationDetails/directEntryApplicationDetails"
	)
);
const LazyDirectEntryPreview = lazy(() =>
	import("../../pages/shared/DirectEntryApplication/directEntryPreview")
);
const LazyTransferLogin = lazy(() =>
	import("../../pages/shared/TransferApplication/transferLogin")
);
const LazyTransferApplication = lazy(() =>
	import("../../pages/shared/TransferApplication/transferApplication")
);
const LazyTransferApplicationDetails = lazy(() =>
	import(
		"../../pages/shared/TransferApplication/TransferApplicationDetails/transferApplicationDetails"
	)
);
const LazyTransferPreview = lazy(() =>
	import("../../pages/shared/TransferApplication/transferPreview")
);
const LazyProspectiveStudents = lazy(() =>
	import("../../pages/shared/ProspectiveStudents/prospectiveStudents")
);
const LazyAdmissionStatusInvoice = lazy(() =>
	import(
		"../../pages/shared/ProspectiveStudents/components/AdmissionStatusInvoice/admissionStatusInvoice"
	)
);
const LazyUnauthorized = lazy(() =>
	import("../../pages/shared/Unauthorized/unauthorized")
);
const LazyPGLogin = lazy(() =>
	import("../../pages/shared/PGApplication/pgLogin")
);
const LazyPGApplication = lazy(() =>
	import("../../pages/shared/PGApplication/pgApplication")
);
const LazyPGReprintLogin = lazy(() =>
	import("../../pages/shared/PGApplication/pgReprintLogin")
);
const LazyPGApplicationDetails = lazy(() =>
	import(
		"../../pages/shared/PGApplication/PGApplicationDetails/pgApplicationDetails"
	)
);
const LazyPGReferenceForm = lazy(() =>
	import("../../pages/shared/PGApplication/pgReferenceForm")
);
const LazyGenerateOtherStudentsPaymentInvoice = lazy(() =>
	import(
		"../../pages/shared/OtherStudents/pages/GenerateOtherStudentsPaymentInvoice/generateOtherStudentsPaymentInvoice"
	)
);
const LazyOtherStudentsInvoice = lazy(() =>
	import(
		"../../pages/shared/OtherStudents/pages/Invoice/otherStudentsInvoice"
	)
);

const LazyCenterOfSafetyApplication = lazy(() =>
	import(
		"../../pages/shared/CenterOfSafetyApplication/centerOfSafetyApplication"
	)
);

const LazyCenterOfSafetyApplicationLogin = lazy(() =>
	import(
		"../../pages/shared/CenterOfSafetyApplication/centerOfSafetyApplicationLogin"
	)
);

const LazyCenterOfSafetyApplicationPreview = lazy(() =>
	import(
		"../../pages/shared/CenterOfSafetyApplication/centerOfSafetyApplicationPreview"
	)
);

const LazySelectCourseRecords = lazy(() =>
	import(
		"../../pages/superAdmin/ApproveCourses/pages/SelectRecords/selectRecords"
	)
);

const LazyViewCoursesRegistered = lazy(() =>
	import(
		"../../pages/superAdmin/ApproveCourses/pages/ViewCoursesRegistered/viewCoursesRegistered"
	)
);

const LazyImpersonationLogin = lazy(() =>
	import("../../pages/shared/ImpersonationLogin")
);

const LazyDownTime = lazy(() => import("../../pages/shared/Downtime/DownTime"));

const LazyRequestApproval = lazy(() =>
	import("../../pages/shared/RequestApproval/requestApproval")
);

const LazyExitVerification = lazy(() =>
	import("../../pages/shared/ExitVerification/exitVerification")
);

export const sharedRoutes = [
	{
		path: "/",
		component: LazyHome,
		router: HomeRouter,
		exact: true
	},
	{
		path: "/admission_process_flow",
		component: LazyAdmissionProcess,
		router: HomeRouter,
		exact: true
	},
	{
		path: "/portal_process_flow",
		component: LazyPortalProcess,
		router: HomeRouter,
		exact: true
	},
	{
		path: "/login",
		component: LazyLogin,
		exact: true
	},
	{
		path: "/forgot_password",
		component: ForgotPassword,
		exact: true
	},
	{
		path: "/change_email",
		component: LazyChangeEmail,
		exact: true
	},
	{
		path: "/reset_password",
		component: LazyResetPassword,
		exact: true
	},
	{
		path: "/verify_otp",
		component: LazyOtpVerfication,
		exact: true
	},
	{
		path: "/verify_account",
		component: LazyVerifyAccount,
		exact: true
	},
	{
		path: "/create_profile",
		component: LazyCreateProfile,
		router: SharedRouter,
		exact: true
	},
	{
		path: "/create_account",
		component: LazyCreateAccount,
		exact: true
	},
	{
		path: "/verify_confirmation",
		component: LazyVerifyConfirmation,
		exact: true
	},
	{
		path: "/generate_sub_degree_invoice",
		component: LazyGenerateJupebStudentsPaymentInvoice,
		router: SharedRouter,
		exact: true
	},
	{
		path: "/jupeb_students_invoice",
		component: LazyJupebStudentsInvoice,
		router: SharedRouter,
		exact: true
	},
	{
		path: "/generate_jamb_students_invoice",
		component: LazyGenerateJambPaymentInvoice,
		router: SharedRouter,
		exact: true
	},
	{
		path: "/jamb_students_invoice",
		component: LazyJambStudentsInvoice,
		router: SharedRouter,
		exact: true
	},
	{
		path: "/generate_cse_invoice",
		component: LazyGenerateCSEInvoice,
		router: SharedRouter,
		exact: true
	},
	{
		path: "/cse_students_invoice",
		component: LazyCSEInvoice,
		router: SharedRouter,
		exact: true
	},
	{
		path: "/sub_degree_login",
		component: LazyJupebApplicationLogin,
		exact: true
	},
	{
		path: "/sub_degree_application",
		router: SharedRouter,
		component: LazyJupebApplication,
		exact: true
	},
	{
		path: "/sub_degree_application/preview",
		router: PreviewRouter,
		component: LazyJupebApplicationPreview,
		exact: true
	},
	{ path: "/putme_login", component: LazyPutmeLogin, exact: true },
	{
		path: "/putme_application",
		router: SharedRouter,
		component: LazyPutmeApplication,
		exact: true
	},
	{
		path: "/putme_application_details",
		router: SharedRouter,
		component: LazyPutmeApplicationDetails,
		exact: true
	},
	{
		path: "/putme_application/preview",
		router: PreviewRouter,
		component: LazyPutmePreview,
		exact: true
	},
	{
		path: "/direct_entry_login",
		component: LazyDirectEntryLogin,
		exact: true
	},
	{
		path: "/direct_entry_application",
		router: SharedRouter,
		component: LazyDirectEntryApplication,
		exact: true
	},
	{
		path: "/direct_entry_application_details",
		router: SharedRouter,
		component: LazyDirectEntryApplicationDetails,
		exact: true
	},
	{
		path: "/direct_entry_application/preview",
		router: PreviewRouter,
		component: LazyDirectEntryPreview,
		exact: true
	},
	{
		path: "/transfer_login",
		component: LazyTransferLogin,
		exact: true
	},
	{
		path: "/transfer_application",
		router: SharedRouter,
		component: LazyTransferApplication,
		exact: true
	},
	{
		path: "/transfer_application_details",
		router: SharedRouter,
		component: LazyTransferApplicationDetails,
		exact: true
	},
	{
		path: "/transfer_application/preview",
		router: PreviewRouter,
		component: LazyTransferPreview,
		exact: true
	},
	{
		path: "/prospective_students",
		router: SharedRouter,
		component: LazyProspectiveStudents,
		exact: true
	},
	{
		path: "/admission_status_reciepts",
		router: SharedRouter,
		component: LazyAdmissionStatusInvoice,
		exact: true
	},
	{
		path: "/no_access",
		component: LazyUnauthorized,
		exact: true,
		router: UnathorisedRouter,
		title: "Unauthorized access"
	},
	{
		path: "/center_of_safety_login",
		component: LazyCenterOfSafetyApplicationLogin,
		exact: true
	},
	{
		path: "/center_of_safety_application",
		router: SharedRouter,
		component: LazyCenterOfSafetyApplication,
		exact: true
	},
	{
		path: "/center_of_safety_application/preview",
		router: PreviewRouter,
		component: LazyCenterOfSafetyApplicationPreview
	},
	{
		path: "/pg_login",
		component: LazyPGLogin,
		exact: true
	},
	{
		path: "/pg_application",
		router: SharedRouter,
		component: LazyPGApplication,
		exact: true
	},
	{
		path: "/pg_reprint_login",
		component: LazyPGReprintLogin,
		exact: true
	},
	{
		path: "/pg_application_details",
		router: SharedRouter,
		component: LazyPGApplicationDetails
	},
	{
		path: "/pg_referee_form",
		router: SharedRouter,
		component: LazyPGReferenceForm,
		exact: true
	},
	{
		path: "/generate_other_students_invoice",
		component: LazyGenerateOtherStudentsPaymentInvoice,
		router: SharedRouter,
		exact: true
	},
	{
		path: "/other_students_invoice",
		component: LazyOtherStudentsInvoice,
		router: SharedRouter,
		exact: true
	},
	{
		path: "/approve_courses",
		component: LazySelectCourseRecords,
		exact: true,
		router: MainRouter,
		title: "Approve & Unapprove Courses"
	},
	{
		path: "/approve_courses/view",
		component: LazyViewCoursesRegistered,
		exact: true,
		router: MainRouter,
		title: "Approve & Unapprove Courses"
	},
	{
		path: "/impersonation_login",
		component: LazyImpersonationLogin,
		exact: true
	},
	{
		path: "/jupeb_login",
		component: LazyJupebApplicationLogin,
		exact: true
	},
	{
		path: "/jupeb_application",
		router: SharedRouter,
		component: LazyJupebApplication,
		exact: true
	},
	{
		path: "/jupeb_application/preview",
		router: PreviewRouter,
		component: LazyJupebApplicationPreview,
		exact: true
	},
	{
		path: "/downtime",
		component: LazyDownTime,
		exact: true
	},
	{
		path: "/parent-exit-approval",
		component: LazyRequestApproval,
		exact: true
	},
	{
		path: "/verify/:exitCode",
		component: LazyExitVerification,
		exact: true
	}
];
